import { asyncLoad } from '@util'

const ContentCenter = asyncLoad(() =>
  import('@components/LocalMerchant/ContentCenter/Index')
)
const MyCreation = asyncLoad(() =>
  import('@components/LocalMerchant/ContentCenter/MyCreation')
)
const CommunityQA = asyncLoad(() =>
  import('@components/LocalMerchant/ContentCenter/CommunityQA')
)

const DynamicDetail = asyncLoad(() =>
  import('@components/LocalMerchant/ContentCenter/DynamicDetail')
)

const Publish = asyncLoad(() =>
  import('@components/LocalMerchant/ContentCenter/Publish')
)

const CommunityDetail = asyncLoad(() =>
  import('@components/LocalMerchant/ContentCenter/CommunityDetail')
)
const PlanDetail = asyncLoad(() =>
  import('@components/LocalMerchant/ContentCenter/PlanDetail')
)

export default [
  {
    path: 'contentCenter',
    component: ContentCenter,
    stat: '内容中心/首页'
  },
  {
    path: 'creation',
    component: MyCreation,
    stat: '内容中心/我的创作'
  },
  {
    path: 'planDetail',
    component: PlanDetail,
    stat: '创星者计划详情'
  },
  {
    path: 'communityQA',
    component: CommunityQA,
    stat: '社区问答'
  },
  {
    path: 'dynamicDetail/:id',
    component: DynamicDetail,
    stat: '动态详情'
  },
  // TODO 这里到时候要替换
  {
    path: 'publish',
    component: Publish,
    stat: '发布动态详情'
  },
  {
    path: 'communityDetail/:id',
    component: CommunityDetail,
    stat: '问答详情'
  }
]
